import SectionHeading from "@/pages/home/components/SectionHeading";
import { guides } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="观影指南"
          align="center"
          title="四步找到今晚要看的片子"
          desc="片单再多，挑片的方法其实就几步。下面这套流程适合拿不定主意的时候照着走一遍。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {guides.map((item, index) => (
            <article
              key={item.step}
              className="relative rounded-lg border border-background-200/80 bg-background-100/60 p-5"
            >
              <span
                className={`font-heading text-3xl font-black ${
                  index % 2 === 0 ? "text-primary-300" : "text-secondary-300"
                }`}
              >
                {item.step}
              </span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-primary-200/70 bg-primary-50 p-5 md:p-7 grid grid-cols-1 md:grid-cols-[1fr_auto] gap-5 items-center">
          <div>
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
              还是选不出来？从这三个入口各挑一部对比
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              分别从热度榜、口碑榜和主题合集里各取一部，看预告或简介再决定，比在原地纠结更快。
            </p>
          </div>
          <a
            href="#ranking"
            className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-trophy-line" />
            打开热门榜单
          </a>
        </div>
      </div>
    </section>
  );
}